import { INCIDENT_QUERY } from "@/features/incidents/graphql/incident-query";
import { Incident } from "@/features/incidents/incident";

export const Route = createFileRoute({
  component: Incident,
  loader: async ({ context, params }) => {
    if (context.urqlClient) {
      await context.urqlClient
        .query(INCIDENT_QUERY, { id: params.id })
        .toPromise();
    }
  },
});
